import { Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import StockTracker from './pages/StockTracker'
import WeatherTracker from './pages/WeatherTracker'
import EventTracker from './pages/EventTracker'
import PetWiki from './pages/PetWiki'
import GameGuide from './pages/GameGuide'
import Settings from './pages/Settings'
import { ApiProvider } from './contexts/ApiContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { ErrorBoundary } from './components/ErrorBoundary'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <NotificationProvider>
          <ApiProvider>
            <Layout>
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/stock" element={<StockTracker />} />
                  <Route path="/weather" element={<WeatherTracker />} />
                  <Route path="/events" element={<EventTracker />} />
                  <Route path="/pets" element={<PetWiki />} />
                  <Route path="/guide" element={<GameGuide />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </ErrorBoundary>
            </Layout>
          </ApiProvider>
        </NotificationProvider>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App 